import { defineMessages } from 'react-intl';

export default defineMessages({
  NO_DATA: {
    defaultMessage: 'Pas de données',
  },

  SELECT_ALL: {
    defaultMessage: 'Sélectionner la page',
  },

  SELECT_ROW: {
    defaultMessage: 'Sélectionner la ligne',
  },
});
